"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toItemType = exports.toItemTransactionKind = exports.toItemSourceType = exports.itemTypeOptions = exports.itemTypeLabel = exports.itemTypeIcon = exports.itemTransactionKindOptions = exports.itemSourceTypeOptions = exports.itemSourceTypeLabel = exports.itemsListPath = exports.itemPagePath = exports.itemKindLabel = exports.itemErrorMessage = exports.itemColumns = exports.newItemPath = exports.ITEM_PAGE_SIZE = exports.ITEM_FIELD_GRID = exports.formatExpiry = exports.describeItemQuantity = exports.describeConsumable = exports.ALL_OPTION = void 0;
var utils_1 = require("@doshexchnage/utils");
var routes_1 = require("../../../../constants/routes");
var ITEM_PAGE_SIZE = 10;
exports.ITEM_PAGE_SIZE = ITEM_PAGE_SIZE;
// container breakpoints, not viewport ones, because the form column shares the row with the preview
var ITEM_FIELD_GRID = "grid grid-cols-1 gap-4 @lg:grid-cols-2 @3xl:grid-cols-3";
exports.ITEM_FIELD_GRID = ITEM_FIELD_GRID;
var ALL_OPTION = "all";
exports.ALL_OPTION = ALL_OPTION;
var itemColumns = [
    { name: "Icon", uid: "icon" },
    { name: "Name", uid: "name" },
    { name: "Type", uid: "type" },
    { name: "Issued", uid: "issued_count" },
    { name: "Held", uid: "held_count" },
    { name: "Availability", uid: "dates_enabled" },
    { name: "Updated", uid: "updated_at" },
    { name: "", uid: "row_actions" },
];
exports.itemColumns = itemColumns;
var itemTypeOptions = [{ key: "badge", label: "Badge", icon: "solar:medal-ribbons-star-linear", stackable: true, route: routes_1.ITEM_BADGES_ROUTE }];
exports.itemTypeOptions = itemTypeOptions;
var itemTransactionKindOptions = [
    { key: "grant", label: "Grant" },
    { key: "revoke", label: "Revoke" },
    { key: "consume", label: "Consume" },
    { key: "expire", label: "Expire" },
];
exports.itemTransactionKindOptions = itemTransactionKindOptions;
var itemSourceTypeOptions = [
    { key: "challenge", label: "Challenge" },
    { key: "reward_track", label: "Reward track" },
    { key: "segment", label: "Segment" },
    { key: "admin", label: "Admin" },
    { key: "migration", label: "Migration" },
    { key: "api", label: "API" },
    { key: "expiry", label: "Expiry" },
];
exports.itemSourceTypeOptions = itemSourceTypeOptions;
var itemTypeLabel = function (itemType) { var _a, _b; return (_b = (_a = itemTypeOptions.find(function (option) { return option.key === itemType; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : itemType; };
exports.itemTypeLabel = itemTypeLabel;
var itemTypeIcon = function (itemType) { var _a, _b; return (_b = (_a = itemTypeOptions.find(function (option) { return option.key === itemType; })) === null || _a === void 0 ? void 0 : _a.icon) !== null && _b !== void 0 ? _b : "solar:box-linear"; };
exports.itemTypeIcon = itemTypeIcon;
var itemSourceTypeLabel = function (sourceType) { var _a, _b; return (_b = (_a = itemSourceTypeOptions.find(function (option) { return option.key === sourceType; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : sourceType; };
exports.itemSourceTypeLabel = itemSourceTypeLabel;
var itemKindLabel = function (kind) { var _a, _b; return (_b = (_a = itemTransactionKindOptions.find(function (option) { return option.key === kind; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : kind; };
exports.itemKindLabel = itemKindLabel;
var itemsListPath = function () { return "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.ITEMS_ROUTE); };
exports.itemsListPath = itemsListPath;
var newItemPath = function (itemType) { var _a, _b; return "".concat(routes_1.CONSOLE_ROUTE).concat((_b = (_a = itemTypeOptions.find(function (option) { return option.key === itemType; })) === null || _a === void 0 ? void 0 : _a.route) !== null && _b !== void 0 ? _b : routes_1.ITEMS_ROUTE).concat(routes_1.NEW_ROUTE); };
exports.newItemPath = newItemPath;
// an unknown type falls back to the generic route, which looks the item up and forwards to its type's page
var itemPagePath = function (itemType, itemId) { var _a, _b; return "".concat(routes_1.CONSOLE_ROUTE).concat((_b = (_a = itemTypeOptions.find(function (option) { return option.key === itemType; })) === null || _a === void 0 ? void 0 : _a.route) !== null && _b !== void 0 ? _b : routes_1.ITEMS_ROUTE, "/").concat(itemId); };
exports.itemPagePath = itemPagePath;
var toItemType = function (value) { var _a; return (_a = itemTypeOptions.find(function (option) { return option.key === value; })) === null || _a === void 0 ? void 0 : _a.key; };
exports.toItemType = toItemType;
var toItemSourceType = function (value) { var _a; return (_a = itemSourceTypeOptions.find(function (option) { return option.key === value; })) === null || _a === void 0 ? void 0 : _a.key; };
exports.toItemSourceType = toItemSourceType;
var toItemTransactionKind = function (value) { var _a; return (_a = itemTransactionKindOptions.find(function (option) { return option.key === value; })) === null || _a === void 0 ? void 0 : _a.key; };
exports.toItemTransactionKind = toItemTransactionKind;
var describeItemQuantity = function (quantityLimited, quantity, issuedCount) {
    return quantityLimited ? "".concat(issuedCount.toLocaleString(), " of ").concat(quantity.toLocaleString(), " issued") : "".concat(issuedCount.toLocaleString(), " issued, unlimited");
};
exports.describeItemQuantity = describeItemQuantity;
var describeConsumable = function (_a) {
    var uses_per_unit = _a.uses_per_unit, expires_after_days = _a.expires_after_days;
    return "".concat(uses_per_unit.toLocaleString(), " ").concat(uses_per_unit === 1 ? "use" : "uses", " per unit, ").concat(expires_after_days ? "expires ".concat(expires_after_days, " ").concat(expires_after_days === 1 ? "day" : "days", " after grant") : "never expires");
};
exports.describeConsumable = describeConsumable;
var formatExpiry = function (value) { return (value ? (0, utils_1.formatDateTime)(new Date(value)) : "Never"); };
exports.formatExpiry = formatExpiry;
var itemErrorMessage = function (error) {
    var _a;
    var failure = error;
    return ((_a = failure === null || failure === void 0 ? void 0 : failure.data) === null || _a === void 0 ? void 0 : _a.message) || (failure === null || failure === void 0 ? void 0 : failure.error) || "The request was unsuccessful.";
};
exports.itemErrorMessage = itemErrorMessage;
